export default "__VITE_ASSET__BhoAByei__"